// :cow: Cosmose CONFIDENTIAL :iso:
import { HttpErrorResponse } from '@angular/common/http';

export const errorMsgHandler = (error: HttpErrorResponse): string => {
  switch (error.status) {
    case 400: {
      if (error.error) {
        return error.error;
      } else {
        return 'error.status400';
      }
    }
    case 403: {
      return 'error.status403';
    }
    case 500:
    case 502:
    case 503: {
      if (error.error) {
        return error.error;
      } else {
        return 'error.status500';
      }
    }
  }

  return 'error.default';
};
